import { Component, computed } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { ContentComponent } from '@campaign-form/form-fields/creators-and-ctas/deliverable-flow-dialog/deliverable-step/deliverable-list/content/content.component';
import { DeliverableFindingsStore } from '@cta-analytics-dialog/deliverable-analytics-content/deliverable-findings.store';
import { EDeliverableType } from '@enums/campaign.enum';
import { IContentAnalytics } from '@interfaces/deliverable-analytics.interface';
import { TranslateModule } from '@ngx-translate/core';
import { MultiMediaPostAnalyticsBaseDirective } from '../multi-media-post-analytics-base/multi-media-post-analytics-base.directive';
import { ICustomPostAnalyticsTableData } from './custom-post-analytics.interface';

@Component({
  imports: [TranslateModule, MatTableModule, MatSortModule, MatButtonModule, ContentComponent],
  providers: [DeliverableFindingsStore],
  selector: 'app-custom-post-analytics',
  templateUrl: './custom-post-analytics.component.html',
})
export class CustomPostAnalyticsComponent extends MultiMediaPostAnalyticsBaseDirective<
  ICustomPostAnalyticsTableData,
  IContentAnalytics
> {
  public override readonly deliverableType = EDeliverableType.content;
  public override readonly displayedColumns: string[] = ['timestamp', 'status', 'actions'];
  public override readonly dataSource: MatTableDataSource<ICustomPostAnalyticsTableData> = new MatTableDataSource();

  public override readonly currentDeliverable = computed(() => {
    const deliverableId = this.deliverableId();
    const executionAnalytics = this.executionAnalyticsWithFindings();

    if (deliverableId && executionAnalytics) {
      return executionAnalytics?.ctaAnalytics?.contents?.find((c) => c.deliverableId === deliverableId);
    }

    return null;
  });

  public readonly currentMedia = computed(() => {
    const { src } = this.videoConfiguration();
    const mediaList = this.media();
    let found = mediaList.find((m) => m.url === src);

    if (!found && mediaList.length > 0) {
      [found] = mediaList;
    }

    return found;
  });

  public override readonly kpiCardData = null;

  protected override setCounts(): void {
    return;
  }

  protected override setKeywordList(): void {
    return;
  }

  protected override getKeywords(): string[] {
    return [];
  }

  protected override prepareChartAndTableData(): void {
    return;
  }
}
